import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function CartsList({ carts, onSelectCart }) {
  const getTotalItemsInCart = (cart) => {
    return cart.tickets.reduce((total, ticket) => total + ticket.cantidad, 0);
  };

  const getTotalPriceInCart = (cart) => {
    return cart.tickets.reduce((total, ticket) => total + (ticket.precio * ticket.cantidad), 0);
  };

  return (
    <div>
      <div className="text-white text-center mb-4">
        <h3 className="text-lg font-bold">Mis Carritos</h3>
        <p className="text-sm text-gray-400">Tienes {carts.length} carrito{carts.length !== 1 ? 's' : ''} de eventos</p>
      </div>
      
      <div className="space-y-3 max-h-[60dvh] overflow-y-auto scrollbar-box thin pr-2">
        {carts.map((cart, index) => {
          const totalItems = getTotalItemsInCart(cart);
          const totalPrice = getTotalPriceInCart(cart);
          
          return (
            <div
              key={cart.eventoId}
              className="bg-aw-bluedark rounded-xl p-4 border border-aw-green hover:border-aw-green-50 transition-colors cursor-pointer"
              onClick={() => onSelectCart(cart)}
            >
              <div className="flex items-center gap-3">
                <img
                  src={cart.eventoImg}
                  alt={cart.eventoNombre}
                  className="w-12 h-12 rounded-lg object-cover border border-aw-green"
                />
                
                <div className="flex-1">
                  <h4 className="text-white font-bold text-sm line-clamp-1">
                    {cart.eventoNombre}
                  </h4>
                  <p className="text-gray-400 text-xs line-clamp-1">
                    {cart.eventoFecha}
                  </p>
                  <p className="text-gray-400 text-xs">
                    <FontAwesomeIcon icon="fa-solid fa-map-marker-alt" className="text-red-500 mr-1" />
                    {cart.eventoUbicacion}
                  </p>
                </div>
                
                <div className="text-right">
                  <p className="text-aw-green font-bold text-lg">
                    ${totalPrice.toLocaleString()}
                  </p>
                  <p className="text-gray-400 text-xs">
                    {totalItems} ticket{totalItems !== 1 ? 's' : ''}
                  </p>
                  <FontAwesomeIcon 
                    icon="fa-solid fa-chevron-right" 
                    className="text-aw-green text-sm mt-1"
                  />
                </div>
              </div>
              
              {/* Quick preview of tickets */}
              <div className="mt-2 pt-2 border-t border-aw-bluedark-50">
                <div className="flex flex-wrap gap-1">
                  {cart.tickets.slice(0, 3).map((ticket, ticketIndex) => (
                    <span
                      key={ticketIndex}
                      className="inline-block bg-aw-bluedark-50 text-white text-xs px-2 py-1 rounded-full"
                    >
                      {ticket.cantidad}x {ticket.customTypeName}
                    </span>
                  ))}
                  {cart.tickets.length > 3 && (
                    <span className="inline-block bg-aw-bluedark-50 text-gray-400 text-xs px-2 py-1 rounded-full">
                      +{cart.tickets.length - 3} más
                    </span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}